<template>
  <HeaderPages />
  <section class="section_header_full_pages">
    <div class="box_img_brand_project">
      <img
        src="@/assets/project/7s/7s.png"
        class="img_brand_project"
        alt="7s"
      />
    </div>
    <div class="waves_full_pages"></div>
    <div class="container_text_full_pages">
      <h1 class="title_home">
        <span class="title_home_4"
          >Современный<br />
          сайт-бренд</span
        >
      </h1>
      <div class="box_button_brifing_full_pages">
        <div class="box_button_v2">
          <button class="button_v1" data-action="toggleBig">
            Оставить заявку
          </button>
        </div>
      </div>
    </div>
  </section>
  <section class="section_main_info_project">
    <div class="container_main_info_project">
      <div class="box_main_info_project_left">
        <p class="font_2_4_700_Kreadon">2024</p>
      </div>
      <div class="box_main_info_project_right">
        <p class="font_2_4_700_Kreadon">SevenStar</p>
      </div>
    </div>
    <div class="container_main_info_project">
      <div class="box_main_info_project_left">
        <p class="subtext_services_design fatty_font">
          <!-- Аналитика<br /> -->
          <!-- UX/UI дизайн<br /> -->
          UX/UI дизайн <BR />
          &nbsp;
          <BR />
          Frontend <BR />
          &nbsp;
          <BR />
          Backend <BR />
          &nbsp;
          <BR />
          DevOps
        </p>
      </div>
      <div class="box_main_info_project_right">
        <p class="subtext_services_design">
          SevenStar – новый бренд, представляющий премиальные товары,
          ориентированные на современный рынок.
        </p>
      </div>
    </div>
    <!-- <div class="container_main_info_project">
        <div class="box_main_info_project_left"></div>
        <div class="box_main_info_project_right">
          <button class="button_light">Сайт</button>
        </div>
      </div> -->
    <div class="container_main_info_project">
      <div class="box_main_info_project_left">
        <p class="subtext_services_design fatty_font">Цели</p>
      </div>
      <div class="box_main_info_project_right">
        <p class="subtext_services_design">
          Создать современный сайт для успешного запуска нового бренда,
          позволяющий эффективно презентовать продукцию, выделить преимущества
          компании и привлечь целевую аудиторию через SEO.
        </p>
      </div>
    </div>
    <div class="container_main_info_project">
      <div class="box_main_info_project_left">
        <p class="subtext_services_design fatty_font">Задачи</p>
      </div>
      <div class="box_main_info_project_right">
        <ul class="list_articles subtext_services_design">
          <li>
            Разработка уникального брендового дизайна с акцентом на стиль и
            премиальность
          </li>
        </ul>
        <ul class="list_articles subtext_services_design">
          <li>Создание удобного каталога товаров</li>
        </ul>
        <ul class="list_articles subtext_services_design">
          <li>
            Разработка блога с SEO-оптимизированными статьями для привлечения
            органического трафика
          </li>
        </ul>
        <ul class="list_articles subtext_services_design">
          <li>
            Внедрение анимаций и интерактивных элементов для улучшения
            пользовательского опыта
          </li>
        </ul>
        <ul class="list_articles subtext_services_design">
          <li>Создать каталог продукции с возможностью просмотра товаров</li>
        </ul>
      </div>
    </div>
    <div class="container_main_info_project">
      <div class="box_main_info_project_left">
        <p class="subtext_services_design fatty_font">Решение</p>
      </div>
      <div class="box_main_info_project_right">
        <div class="flex_gap_0_45">
          <p class="font_1_400_Kreadon_Regular color_violet">01</p>
          <p class="subtext_services_design">
            <span class="fatty_font"
              >Разработка фирменного стиля и брендинга</span
            ><BR />
            &nbsp;
            <BR />Мы полностью разработали айдентику компании: логотип, цветовую
            палитру, визуальный стиль упаковки и маркетинговые материалы.
            Основной акцент сделан на премиальный и минималистичный дизайн,
            который привлекает внимание и подчеркивает статус бренда.
          </p>
        </div>
        <div class="flex_gap_0_45">
          <p class="font_1_400_Kreadon_Regular color_violet">02</p>
          <p class="subtext_services_design">
            <span class="fatty_font">Современный UX/UI-дизайн</span>
            <BR />
            &nbsp;
            <BR />
            Наши дизайнеры создали стильный и удобный интерфейс с акцентом на
            легкость восприятия информации. В дизайне использованы плавные
            анимации и интерактивные элементы, создающие эффект премиальности.
          </p>
        </div>
      </div>
    </div>
    <div class="container_slaider_project">
      <button class="custom-prev">
        <img
          class="arrow_left_slider"
          src="@/assets/elements/arrow_right.svg"
          alt="стрелка"
        />
      </button>

      <button class="custom-next">
        <img
          class="arrow_right_slider"
          src="@/assets/elements/arrow_right.svg"
          alt="стрелка"
        />
      </button>
      <swiper
        :modules="modules"
        :slides-per-view="1"
        loop="true"
        class="mySwiper"
        :navigation="{
          nextEl: '.custom-next',
          prevEl: '.custom-prev',
        }"
      >
        <swiper-slide v-for="(slide, index) in slides" :key="index">
          <img :src="slide" class="slide-content" alt="Слайд проекта" />
        </swiper-slide>
      </swiper>
    </div>

    <div class="container_main_info_project">
      <div class="box_main_info_project_left"></div>
      <div class="box_main_info_project_right">
        <div class="flex_gap_0_45">
          <p class="font_1_400_Kreadon_Regular color_violet">03</p>
          <p class="subtext_services_design">
            <span class="fatty_font"> Разработка каталога продукции</span>
            <BR />
            &nbsp;
            <BR />
            Система каталога включает удобную навигацию и детальные карточки
            товаров с описанием характеристик и фото.
          </p>
        </div>
        <div class="flex_gap_0_45">
          <p class="font_1_400_Kreadon_Regular color_violet">04</p>
          <p class="subtext_services_design">
            <span class="fatty_font">SEO-оптимизированный блог</span>
            <BR />
            &nbsp;
            <BR />
            Для привлечения трафика и повышения видимости в поисковых системах
            был разработан блог с экспертными статьями, соответствующими
            поисковым запросам целевой аудитории.
          </p>
        </div>
        <div class="flex_gap_0_45">
          <p class="font_1_400_Kreadon_Regular color_violet">05</p>
          <p class="subtext_services_design">
            <span class="fatty_font">Интерактивные элементы и анимации</span>
            <BR />
            &nbsp;
            <BR />
            Сайт оживлен динамическими эффектами, плавными переходами и
            анимацией при прокрутке, создавая премиальное восприятие бренда.
          </p>
        </div>
      </div>
    </div>
    <swiper
      :modules="modules"
      :slides-per-view="slidesPerView"
      loop="true"
      class="mySwiper_2"
    >
      <swiper-slide v-for="(slides_2, index) in slides_2" :key="index">
        <img :src="slides_2" class="simg_project" alt="Слайд проекта" />
      </swiper-slide>
    </swiper>
    <!-- <div class="container_img_project">
      <img class="img_project" src="@/assets/background/test.png" />
      <img class="img_project" src="@/assets/background/test.png" />
      <img class="img_project" src="@/assets/background/test.png" />
    </div> -->
    <div class="container_main_info_project">
      <div class="box_main_info_project_left">
        <p class="subtext_services_design fatty_font">Результат</p>
      </div>
      <div class="box_main_info_project_right">
        <div class="flex_gap_0_45">
          <p class="font_1_400_Kreadon_Regular">-</p>
          <p class="subtext_services_design">
            Фирменный стиль и айдентика бренда полностью разработаны с нуля
          </p>
        </div>
        <div class="flex_gap_0_45">
          <p class="font_1_400_Kreadon_Regular">-</p>
          <p class="subtext_services_design">
            Создан современный, премиальный сайт с удобным каталогом продукции
          </p>
        </div>
        <div class="flex_gap_0_45">
          <p class="font_1_400_Kreadon_Regular">-</p>
          <p class="subtext_services_design">
            SEO-блог начал привлекать органический трафик и расширять аудиторию
            бренда
          </p>
        </div>
        <div class="flex_gap_0_45">
          <p class="font_1_400_Kreadon_Regular">-</p>
          <p class="subtext_services_design">
            Привлекательный и удобный UX/UI-дизайн повысил вовлеченность
            пользователей
          </p>
        </div>
      </div>
    </div>
    <!-- <div class="container_main_info_project">
        <div class="box_main_info_project_left"></div>
        <div class="box_main_info_project_right">
          <div class="flex_space_between">
            <p class="subtext_services_design">
              <span class="font_2_4_700_Kreadon color_violet">10000</span>
              <BR />
              Рейтинги
            </p>
            <p class="subtext_services_design">
              <span class="font_2_4_700_Kreadon color_violet">10000</span>
              <BR />
              Рейтинги
            </p>
          </div>
        </div>
      </div> -->
    <div class="container_main_info_project">
      <div class="box_main_info_project_left">
        <p class="subtext_services_design fatty_font">Команда</p>
      </div>
      <div class="box_main_info_project_right_row">
        <ul class="ul_team subtext_services_design">
          <span class="color_violet">Команда</span>
          <li>Дизайн и брендинг: Стрельцова Валерия</li>
          <li>Frontend-разработка: Рахманов Рахман</li>
          <li>Backend и DevOps : Кошелев Ростислав</li>
        </ul>
      </div>
    </div>
  </section>
  <SectionBlog />
  <SectionProjects />
  <FooterPages />
</template>
<script>
import { useHead } from "@vueuse/head";
import { ref, onMounted } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

import HeaderPages from "../permanent/HeaderPages.vue";
import FooterPages from "../permanent/FooterPages.vue";
import SectionBlog from "../ui/SectionBlog.vue";
import SectionProjects from "../ui/SectionProjects.vue";
import slide_1 from "@/assets/project/7s/7s_slide_1.webp";
import slide_2 from "@/assets/project/7s/7s_slide_2.webp";
import slide_3 from "@/assets/project/7s/7s_slide_3.webp";
import slide_4 from "@/assets/project/7s/7s_slide_4.webp";
import slide_5 from "@/assets/project/7s/7s_slide_5.webp";

import slide_1_m from "@/assets/project/7s/7s_slide_1_m.webp";
import slide_2_m from "@/assets/project/7s/7s_slide_2_m.webp";
import slide_3_m from "@/assets/project/7s/7s_slide_3_m.webp";
import slide_4_m from "@/assets/project/7s/7s_slide_4_m.webp";
import slide_5_m from "@/assets/project/7s/7s_slide_5_m.webp";

export default {
  components: {
    Swiper,
    SwiperSlide,
    HeaderPages,
    FooterPages,
    SectionBlog,
    SectionProjects,
  },

  setup() {
    useHead({
      title:
        "Создание премиального сайта-бренда SevenStar | UX/UI, Frontend, Backend, SEO",
      meta: [
        {
          name: "description",
          content:
            "Разработка современного сайта-бренда SevenStar с уникальным дизайном, удобным каталогом товаров, SEO-оптимизированным блогом и интерактивными элементами. UX/UI-дизайн, frontend и backend-разработка, DevOps. Узнайте, как мы помогли вывести бренд в премиальный сегмент!",
        },
      ],
    });
    const slides = [slide_1, slide_2, slide_3, slide_4, slide_5];
    const slides_2 = [slide_1_m, slide_2_m, slide_3_m, slide_4_m, slide_5_m];

    const slidesPerView = ref(3);

    const updateSlidesPerView = () => {
      if (window.innerWidth <= 767) {
        slidesPerView.value = 2;
      } else {
        slidesPerView.value = 3;
      }
    };
    onMounted(() => {
      updateSlidesPerView();
      window.addEventListener("resize", updateSlidesPerView);
    });
    return {
      slides,
      slides_2,
      updateSlidesPerView,
      slidesPerView,
      modules: [Navigation],
    };
  },
};
</script>
<style scoped>
.container_main_info_project {
  height: fit-content;
}
.section_main_info_project {
  gap: 2.5rem;
}

.section_header_full_pages {
  background: linear-gradient(
    157.17deg,
    rgb(247, 46, 90) -1.537%,
    rgb(248, 255, 179) 80.248%
  );
}
.img_brand_project {
  width: 17.4rem;
  height: 16.2rem;
}
.box_img_brand_project {
  position: absolute;
  right: 6.5rem;
  top: 8rem;
}
.simg_project {
  height: 37rem;
  border-radius: 1.7rem;
  box-shadow: 0.7rem 0.7rem 2rem -0.8rem rgba(71, 86, 163, 0.4);
  background: rgb(245, 247, 255);
}
.fatty_font {
  font-family: Kreadon-Bold !important;
}
.mySwiper_2 {
  padding-bottom: 4rem;
}
@media (max-width: 767px) {
  .container_text_full_pages {
    padding: 11rem 2rem 4.5rem 2rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .section_header_full_pages {
    height: 51.36rem;
  }
  .title_home {
    z-index: 0;
  }
  .img_brand_project {
    width: 22.45rem;
    height: 20.91rem;
  }
  .box_img_brand_project {
    position: absolute;
    right: 2rem;
    top: 19rem;
  }
  .simg_project {
    height: 28rem;
    box-shadow: 1.27rem 1.27rem 3.64rem -1.45rem rgba(71, 86, 163, 0.4);
  }
  .mySwiper_2 {
    padding-left: 1.5rem;
    padding-bottom: 4rem;
  }
  .container_main_info_project {
    flex-direction: column;
  }
  .ul_team .color_violet {
    display: none;
  }
  .font_1_400_Kreadon_Regular {
    line-height: 1.27rem;
  }
  .container_slaider_project {
    margin: 0rem;
  }
}
</style>
